<template>
  <a-modal :open="open" @cancel="closeForm">
    <h2>Вы уверены, что хотите удалить "{{ currentGroup?.id ? ('группу ' + currentGroup.name) :
        ('группы (' + selectedGroups.length + ')') }}"?</h2>
    <a-divider style="margin: 16px 0" />
    <p class="modal-text">
      После удаления сотрудники будут отвязаны от группы.
    </p>

    <template #footer>
      <a-divider />
      <div class="action-buttons">
        <a-row justify="end" :gutter="8">
          <a-col>
            <a-button class="secondary-button" @click="closeForm">Отменить</a-button>
          </a-col>
          <a-col>
            <a-button class="primary-button" :loading="modalActionLoading" @click="handleDeleteGroups">Удалить</a-button>
          </a-col>
        </a-row>
      </div>
    </template>
  </a-modal>
</template>

<script>
import {message} from "ant-design-vue";
import {useStore} from "vuex";
import {ref} from "@vue/runtime-core";

export default {
  props: {
    open: Boolean,
    currentGroup: Object,
    selectedGroups: Array,
  },
  emits: ['submitted', 'close'],
  setup(props, context) {
    const store = useStore();
    const modalActionLoading = ref(false);

    const handleDeleteGroups = () => {
      modalActionLoading.value = true;

      let groups = [];
      if (props.currentGroup?.id) {
        groups.push(props.currentGroup.id);
      } else {
        groups = props.selectedGroups;
      }

      store.dispatch('group/deleteGroups', groups).then(() => {
        message.success('Группа удалена');
        context.emit('submitted');
      }).finally(() => {
        modalActionLoading.value = false;
      });
    }

    const closeForm = () => {
      context.emit('close');
    }

    return {
      modalActionLoading,
      closeForm,
      handleDeleteGroups
    }
  }
}
</script>

<style scoped lang="scss">

</style>